import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import { format_project_request_data, PROJECT_STATUS } from '../../utils/projects';
import ProjectForm from '../ProjectForm/ProjectForm';

import './CreateProject.css';

interface Props{
    onCreate?: Function
    data?: string
}
interface State{
    creating: boolean

    // Creation 
    data: any
}



export default class CreateProject extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            creating: false,
            // creating: false,
            data: {
                status: PROJECT_STATUS[0],
                ...this.default_values()
            }
        }
    }

    default_values = () => {
        return {
            name: '',
            
            start_date: '',
            planned_start_date: '',
            completion_date: '',
            planned_completion_date: '',

            collection: '',
            consolidation: '',
            integration: '',
            processing: '',
            repatriation: '',
            extraction: '',
            update: '',
            packaging: '',

            objective: '',
        }
    }
    
    render(){
        return (
            <div className="create-project">
                <ProjectForm
                    data={this.state.data}
                    onChange={(updates:any)=>{
                        this.setState({
                            data: {
                                ...this.state.data,
                                ...updates
                            }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.creating
                        })}
                        onClick={this.create}
                    >
                        {
                            this.state.creating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-plus"/> ADD PROJECT</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    create = async() =>{
        let { data } = this.state;

        this.setState({ creating: true })
        try{

           format_project_request_data(data);
           
            let res = await request(`${API_URL}/api/v1/projects`,{
                method:'post',
                data: data,
            })

            this.props.onCreate?.();
            this.setState({
                data: {
                    ...data,
                    ...this.default_values()
                } 
            });

            create_toast({ type: 'success', message: `Successfully created project ${res.data.value.name}` })
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'create'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ creating: false })
        }
    }
};